module.exports = __webpack_public_path__ + "static/media/Logo_monclova.8a5f4cb4.png";